import React, {Component} from 'react'
import {request} from "../../helper/APIUtils";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import DefaultModal from "../invoice/DefaultModal";
import {validateField} from "../../common/validation";
import moment from "moment/moment";
import {Button, Col, Form, FormGroup, Input, Label} from "reactstrap";
import Datetime from "react-datetime";
import TextEditor from "../../components/TextEditor"
import {isValidSurvey} from "../../common/componentValidation";
import Alert from "react-s-alert";
import MultiSelectSurvey from "../../components/MultiSelectSurvey";

class SurveyModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: {},
            data: {},
            processing: false,
            excludeDistributorsList: [],
            includeDistributorsList: [],
            includeCitiesList: [],
            surveyOptions: ['']
        };
        this.save = this.save.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.validateField = this.validateField.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.checkDateValidity = this.checkDateValidity.bind(this);
    }

    async componentDidMount() {
        let {mode, recordId} = this.props;

        if ((mode === "update") && recordId) {
            let self = this;
            let params = {
                url: "/survey/fetchSurveyByRecordId",
                method: 'post',
                data: recordId
            };
            request(params).then(function (response) {
                self.setState({data: response.data});

            }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            let surveyDetails = this.state.surveyDetails;
            this.setState({surveyDetails});
        }
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }


    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    handleOptionChange = (index, value) => {
        const surveyOptions = [...this.state.surveyOptions];
        surveyOptions[index] = value;
        this.setState({ surveyOptions });
    }

    addOption = () => {
        this.setState((prevState) => ({
            surveyOptions: [...prevState.surveyOptions, '']
        }));
    }

    removeOption = (index) => {
        this.setState((prevState) => ({
            surveyOptions: prevState.surveyOptions.filter((_, i) => i !== index)
        }));
    };


    handleInputChange(name, value) {
        let data = this.state.data;
        let includeDistributorsList = deepCopyObject(this.state.includeDistributorsList);
        let excludeDistributorsList = deepCopyObject(this.state.excludeDistributorsList);
        if (name === "includeDistributors") {
            includeDistributorsList = value;
        }
        if (name === "excludeDistributors") {
            excludeDistributorsList = value;
        }
        if (name === "showAll") {
            data["includeDistributors"] = "";
            data["excludeDistributors"] = "";
            excludeDistributorsList = [];
            includeDistributorsList = [];
        }
        data[name] = value;
        this.setState({data, excludeDistributorsList, includeDistributorsList});
    }

    onChangeDate = (momentObj, type, fieldValue) => {
        let value;
        if (!(typeof momentObj === "string")) {
            value = momentObj.format("YYYY-MM-DDTHH:mm:ss");
        } else {
            value = momentObj;
            if (type === "datetime" && moment(value, "DD-MM-YYYY", true).isValid()) {
                value = moment(value, "DD-MM-YYYY", true).format("YYYY-MM-DDTHH:mm:ss");
            }
        }
        let data = this.state.data;
        data[fieldValue] = value;
        this.setState({data});
    }

    checkDateValidity(current, name) {
        let data = deepCopyObject(this.state.data);
        let copyCurrent = current.clone();
        if (name === 'startDate') {
            return moment(copyCurrent).isValid;
        }
        if (name === 'endDate') {
            return copyCurrent.isAfter(data.startDate);
        }
    }

    onCancel() {
        this.props.listener(false, false);
    }

    save(e) {
        e.preventDefault();
        let data = deepCopyObject(this.state.data);
        let self = this;
        let includeDistributorsList = deepCopyObject(this.state.includeDistributorsList);
        let excludeDistributorsList = deepCopyObject(this.state.excludeDistributorsList);
        let surveyOptions = deepCopyObject(this.state.surveyOptions);
        data.excludeDistributors = excludeDistributorsList;
        data.includeDistributors = includeDistributorsList;
        data.surveyOptions = surveyOptions;
        let excludeDistributors = "";
        let includeDistributors = "";
        let surveyOption = "";
        if (data.excludeDistributors !== null && data.excludeDistributors !== undefined && data.excludeDistributors !== "") {
            data.excludeDistributors.map((id, index) => {
                excludeDistributors = excludeDistributors + (index + 1 === data.excludeDistributors.length ? id.value : id.value + ",")
            });
        }
        if (data.includeDistributors !== null && data.includeDistributors !== undefined && data.includeDistributors !== "") {
            data.includeDistributors.map((id, index) => {
                includeDistributors = includeDistributors + (index + 1 === data.includeDistributors.length ? id.value : id.value + ",")
            });
        }
        if (data.surveyOptions !== null && data.surveyOptions !== undefined && data.surveyOptions !== "") {
            data.surveyOptions.map((id, index) => {
                surveyOption = surveyOption + (index + 1 === data.surveyOptions.length ? id.value : id.value + ",")
            });
        }
        data.excludeDistributors = excludeDistributors;
        data.includeDistributors = includeDistributors;
        data.surveyOptions = surveyOptions;
        let result = isValidSurvey(data);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            let params = {
                url: `/survey/saveSurvey`,
                method: `post`,
                data: data
            };
            self.setState({processing: true});
            request(params).then(response => {
                Alert.success(("Anketiniz başarıyla kaydedilmiştir."), {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 3000
                });
                self.setState({data: response.data, error: {}}, () => this.props.toggleModal(false, true))
            }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({error});
        }
    }

    render() {
        let data = this.state.data;
        let surveyOptions = this.state.surveyOptions ? this.state.surveyOptions : data.surveyOptions;
        return (
            <DefaultModal
                isOpen={this.props.modal}
                title={`Duyuru ${this.props.mode === "create" ? "Oluştur" : "Düzenle"} `}
                size="lg"
                modalBodyStyle={{padding: "0"}}
                confirmBtnText={"Kaydet"}
                cancelBtnText={"İptal"}
                onConfirm={(e) => this.save(e)}
                onCancel={this.onCancel}>
                <Form className="px-4">
                    <FormGroup row>
                        <Label sm={4}>Anket Başlığı</Label>
                        <Col sm={8} className={this.validateClass("title")}>
                            <Input type="text" name="title" id="title" value={data && data.title ? data.title : ''}
                                   onChange={(e) => this.handleInputChange("title", e.target.value)}
                                   onBlur={(e) => this.validateField(e)}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Seçenekler</Label>
                        <Col sm={8}>
                            {surveyOptions.map((survey, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                    <Input type="text" value={survey}
                                           onChange={(e) => this.handleOptionChange(index, e.target.value)}
                                           placeholder={`Seçenek ${index + 1}`} />
                                    {index === 0 && (
                                        <Button color="success" style={{ marginLeft: '10px', padding: '5px 10px' }} onClick={this.addOption}>
                                            <i className="fa fa-plus" />
                                        </Button>
                                    )}
                                    {surveyOptions.length > 1 && index !== 0 && (
                                        <Button color="danger" style={{ marginLeft: '10px', padding: '5px 10px' }} onClick={() => this.removeOption(index)}>
                                            <i className="fa fa-trash" />
                                        </Button>
                                    )}
                                </div>
                            ))}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Başlangıç Tarihi</Label>
                        <Col sm={8} className={this.validateClass("startDate")}>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      input={true}
                                      closeOnSelect={true}
                                      inputProps={{id: 'startDate'}}
                                      onBlur={(momentObj) => this.validateField({
                                          target: {
                                              id: "startDate",
                                              dataset: {'vdata': "datetime"},
                                              value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                          }
                                      })}
                                      value={moment(data.startDate, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(data.startDate, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
                                          moment(data.startDate).format("DD-MM-YYYY HH:mm:ss") :
                                          data.startDate}
                                      isValidDate={(current) => this.checkDateValidity(current, 'startDate')}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm:ss"
                                      onChange={(e) => this.onChangeDate(e, "date", "startDate")}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Bitiş Tarihi</Label>
                        <Col sm={8} className={this.validateClass("endDate")}>
                            <Datetime locale="tr"
                                      className="datepicker"
                                      inputProps={{id: 'endDate'}}
                                      onBlur={(momentObj) => this.validateField({
                                          target: {
                                              id: "endDate",
                                              dataset: {'vdata': "datetime"},
                                              value: (!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY HH:mm:ss") : momentObj)
                                          }
                                      })}
                                      input={true}
                                      closeOnSelect={true}
                                      value={moment(data.endDate, "YYYY-MM-DDTHH:mm:ss", true).isValid() || moment(data.endDate, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
                                          moment(data.endDate).format("DD-MM-YYYY HH:mm:ss") :
                                          data.endDate}
                                      isValidDate={(current) => this.checkDateValidity(current, 'endDate')}
                                      dateFormat="DD-MM-YYYY"
                                      timeFormat="HH:mm:ss"
                                      onChange={(e) => this.onChangeDate(e, "date", "endDate")}/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={4}>Anket İçeriği</Label>
                        <Col sm={8} className={this.validateClass("content")}>
                            <TextEditor
                                name="content"
                                mode={this.props.mode}
                                listener={this.handleInputChange}
                                content={this.state.data}
                                onBlur={this.validateField}
                            />
                        </Col>
                    </FormGroup>
                    {!data.showAll &&
                        <FormGroup row>
                            <Label sm={4}>Gözükecek Bayiler</Label>
                            <Col sm={8}>
                                <MultiSelectSurvey
                                    mode={this.props.mode}
                                    listener={this.handleInputChange}
                                    name={"includeDistributors"}
                                    content={this.state.includeDistributorsList}
                                    includeDistributorsList={this.state.includeDistributorsList}
                                    options={this.props.allDistributors}
                                />
                            </Col>
                        </FormGroup>
                    }
                    {!data.showAll &&
                        <FormGroup row>
                            <Label sm={4}>Gözükmeyecek Bayiler</Label>
                            <Col sm={8}>
                                <MultiSelectSurvey
                                    mode={this.props.mode}
                                    listener={this.handleInputChange}
                                    name={"excludeDistributors"}
                                    excludeDistributorsList={this.state.excludeDistributorsList}
                                    content={this.state.excludeDistributorsList}
                                    options={this.props.allDistributors}
                                />
                            </Col>
                        </FormGroup>
                    }
                    {(!data.excludeDistributors && !data.includeDistributors) &&
                        <FormGroup row>
                            <Label sm={4}>Tüm Müşterilerde Gözüksün</Label>
                            <Col sm={8}>
                                <input type="checkbox" name="showAll"
                                       value={data.showAll}
                                       checked={data.showAll}
                                       onChange={e => this.handleInputChange("showAll", e.target.checked)}/>
                            </Col>
                        </FormGroup>
                    }
                </Form>
            </DefaultModal>
        )
    }
}

export default SurveyModal;